const dataContent = [
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
  { label: 'Lorem ipsum dolor sit amet, consec', link: '/' },
];

function SideBarNav({ data = dataContent, title }) {
  return (
    // <div className="py-10 mr-4 w-[25%]">
    <div
      className="py-6
       
        md:py-10
        md:sticky md:top-4
        md:h-[calc(100vh-2rem)]
        md:overflow-auto
        "
      style={{
        WebkitOverflowScrolling: 'touch', // smoother iOS scrolling
        overscrollBehavior: 'contain', // prevent scroll chaining
      }}
    >
      <div>
        <h2>{title}</h2>
      </div>
      <nav className="">
        <ul>
          {data.map((dt, i) => (
            <li key={i} className="my-4 hover:underline ">
              {/* <Link to={dt.link}>{dt.label}</Link> */}
              <a href={dt.link}>{dt.label}</a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default SideBarNav;
